/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import PlayArrowSvg from 'bundles/video-player/components/video/PlayButton/PlayArrowSvg';
import PlayButtonScrimSvg from 'bundles/video-player/components/video/PlayButton/PlayButtonScrimSvg';

import _t from 'i18n!nls/video-player';

const styles = {
  playButtonContainer: css`
    position: absolute;
    bottom: 0;
    height: 100%;
    width: 100%;
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  button: css`
    cursor: pointer;
    position: relative;
    width: 124px;
    height: 124px;

    &:hover svg:first-of-type {
      opacity: 0.4;
    }
  `,
  scrim: css`
    position: absolute;
    top: 0;
    left: 0;
    transition: opacity 0.2s cubic-bezier(0, 0, 0.2, 1);
  `,
  arrow: css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  `,
};

type Props = {
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  onKeyPress: (event: React.KeyboardEvent<HTMLElement>) => void;
  haspopup?: boolean;
  videoName?: string;
};

const PlayButton = ({ onClick, onKeyPress, haspopup, videoName }: Props) => {
  const buttonLabel = videoName ? _t('Play Video for #{videoName}', { videoName }) : _t('Play Video');

  return (
    <div
      role="presentation"
      onClick={onClick}
      onKeyPress={onKeyPress}
      className="rc-PlayButton horizontal-box align-items-absolute-center"
      css={styles.playButtonContainer}
    >
      <button
        type="button"
        className="vjs-button"
        aria-disabled="false"
        aria-haspopup={haspopup ? true : undefined}
        aria-label={buttonLabel}
        aria-live="off"
        onClick={onClick}
        onKeyDown={onKeyPress}
        css={styles.button}
      >
        <PlayButtonScrimSvg css={styles.scrim} />
        <PlayArrowSvg css={styles.arrow} width={70} height={70} />
        <span className="vjs-control-text">{buttonLabel}</span>
      </button>
    </div>
  );
};

PlayButton.defaultProps = {
  haspopup: true,
};

export default PlayButton;
